import type { MediaUrl } from '@/types/api';

interface TweetMediaProps {
  media: MediaUrl[];
  onImageClick: (url: string) => void;
}

export function TweetMedia({ media, onImageClick }: TweetMediaProps) {
  if (media.length === 0) return null;

  const gridClass = media.length === 1 ? 'single' : media.length === 2 ? 'double' : '';

  return (
    <div className={`tweet-media grid gap-2 mt-3 ${gridClass}`}>
      {media.map((item, index) => {
        const isVideo = item.type === 'video' && item.video_url;
        const isGif = item.type === 'animated_gif' && item.video_url;
        const isPhoto = !isVideo && !isGif;

        return (
          <div key={index} className="media-container relative w-full">
            {isPhoto && (
              <img
                src={item.url}
                alt="媒体"
                className="w-full rounded-media cursor-pointer transition-opacity hover:opacity-90"
                onClick={() => onImageClick(item.url)}
              />
            )}
            {isVideo && item.video_url && (
              <video
                src={item.video_url}
                poster={item.url}
                controls
                className="w-full rounded-media"
                preload="metadata"
              />
            )}
            {isGif && item.video_url && (
              <video
                src={item.video_url}
                poster={item.url}
                autoPlay
                loop
                playsInline
                muted
                className="w-full rounded-media"
                preload="metadata"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
